import { lazy, Suspense, type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Lazy-loaded like invoicing: Tollit-only finance screens that no other role
 * should download. Kept in its own file so router.tsx's Fast Refresh boundary
 * stays just the route table.
 */
const SupplierInvoicesScreen = lazy(() =>
  import('@/screens/finance/supplierInvoices/SupplierInvoicesScreen').then((module) => ({
    default: module.SupplierInvoicesScreen,
  })),
);

const SupplierInvoiceReviewScreen = lazy(() =>
  import('@/screens/finance/supplierInvoices/SupplierInvoiceReviewScreen').then((module) => ({
    default: module.SupplierInvoiceReviewScreen,
  })),
);

function Fallback() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

function WithFallback({ children }: { children: ReactNode }) {
  return <Suspense fallback={<Fallback />}>{children}</Suspense>;
}

export function LazySupplierInvoicesScreen() {
  return (
    <WithFallback>
      <SupplierInvoicesScreen />
    </WithFallback>
  );
}

export function LazySupplierInvoiceReviewScreen() {
  return (
    <WithFallback>
      <SupplierInvoiceReviewScreen />
    </WithFallback>
  );
}
